import React from "react";
import Loader from "@qlik/qlik/src/assets/images/spinner.gif";

const Preloader = ({ alt = "", className = null }) => <img alt={alt} className={className} src={Loader} />;

export default Preloader;
